import { ParametrePondere } from "./../../../models/ParametrePondere";
import { FondsPropresService } from "src/app/fonds-propres/services/fonds-propres.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-pondere-modal",
  templateUrl: "./pondere-modal.component.html",
  styleUrls: ["./pondere-modal.component.scss"],
})
export class PondereModalComponent implements OnInit {
  form: FormGroup;
  pressButton: Boolean = false;
  //From DB
  parametrePondere: ParametrePondere;
  title: string;
  loading = false;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private shared: FondsPropresService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.form = this.createForm(this.parametrePondere);
  }

  createForm(data: any) {
    return this.fb.group({
      id: [data ? data.id : ""],
      codeSegmentPrudentiel: [
        data ? data.codeSegmentPrudentiel : "",
        Validators.compose([Validators.required]),
      ],
      codeRule: [
        data ? data.codeRule : "",
        Validators.compose([Validators.required]),
      ],
      codeEntity: [data ? data.codeEntity : ""],
      libelleEntity: [data ? data.libelleEntity : ""],
      tailleProvision: [
        data ? data.tailleProvision : "",
        Validators.compose([Validators.pattern("^[0-9]*$")]),
      ],
      isActive: [data ? data.isActive : ""],
      devise: [data ? data.devise : ""],
      zoneRegionale: [data ? data.zoneRegionale : ""],
      ponderation: [
        data ? data.ponderation : "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
        ]),
      ],
    });
  }

  onSubmit() {
    this.submitted = true;
    // reset alerts on submit
    //this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    if (!this.parametrePondere) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  updateData() {
    this.shared.updateParametrePondere(this.form.value).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      },
      () => {
        //redirectTo
        //window.location.reload();
        //this.tabGroup.selectedIndex = 1;
      }
    );
  }

  createData() {
    this.shared.saveParametrePondere(this.form.value).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      },
      () => {
        //redirectTo
        //window.location.reload();
        //this.tabGroup.selectedIndex = 1;
      }
    );
  }
}
